<template>
  <div class="promotion-12-plus-3-view default-page">
    <img
      :src="bannerImage"
      alt="Акція 6+1 від Crystal"
      class="default-page__banner mb-5"
    />
    <h1>Акція «12+3»</h1>
    <div class="default-page-section">
      Отримайте 3 місяці в подарунок при передплаті на рік!
    </div>
    <div class="default-page-section">
      <ul>
        <li><span>📱</span> Завантажте застосунок My Crystal</li>
        <li><span>💳</span> Поповніть рахунок на суму 12 абонплат</li>
        <li><span>🎁</span> +3 місяці нарахуються автоматично!</li>
      </ul>
    </div>
    <div class="default-page-section">
      💰 Ціна заморожується – жодних подорожчань на 15 місяців! ❄️🔒
    </div>
    <div class="default-page-section mb-0">
      <router-link :to="{ name: 'mobile-app' }">
        <app-btn class="btn btn-primary w-100">
          Завантажити застосунок
        </app-btn>
      </router-link>
    </div>
  </div>
</template>

<script>
import AppBtn from "@/components/common/ui/AppBtn.vue";
import bannerImage from "@/assets/promotions/banner-stock-2.jpg";

export default {
  name: "Promotion12plus3View",
  components: {
    AppBtn,
  },
  setup() {
    return {
      bannerImage,
    };
  },
};
</script>

<style scoped lang="less">
@import "@/styles/_mixins.less";

.promotion-12-plus-3-view {
  .default-page-section {
    .default-ul-list();
  }
}
</style>
